export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "page": {
          "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Notifications"])}
        }
      },
      "ru": {
        "page": {
          "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Уведомления"])}
        }
      },
      "es": {
        "page": {
          "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Notificaciones"])}
        }
      },
      "kk": {
        "page": {
          "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Хабарландырулар"])}
        }
      },
      "uz": {
        "page": {
          "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bildirishnomalar"])}
        }
      },
      "de": {
        "page": {
          "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benachrichtigungen"])}
        }
      },
      "fr": {
        "page": {
          "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Notifications"])}
        }
      },
      "it": {
        "page": {
          "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Notifiche"])}
        }
      }
    }
  })
}
